function initializeCheckout (form) {
  const separateInvoice = form.querySelector('input[name="separate_billing_address"]');
  separateInvoice.addEventListener('change', (e) => {
    form.classList.toggle('separate-billing-address', e.target.checked);
  });

  form.classList.toggle('separate-billing-address', separateInvoice.checked);
}

const checkoutForm = document.body.querySelector('.checkout');
if (checkoutForm) {
  initializeCheckout(checkoutForm);
}
